import { Stack, Grid } from "@mui/material";
import styled from "styled-components";
import { theme } from "styles/mui-config";

export const StyledStack = styled(Stack)`
  background-color: ${theme.palette.secondary.light};
  border-radius: 4px;
  box-shadow: 0 0 5px ${theme.palette.shadow.main};
  margin-top: 30px;
  width: 100%;
  padding: 20px;
  padding-top: 15px;
`;

export const StyledTitle = styled.div`
  width: 100%;
  padding: 10px;
  padding-bottom: 20px;
  border-bottom: 2px solid ${theme.palette.primary.main};
  margin-bottom: 20px;
  font-family: IRANSans;
  font-weight: 500;
  font-size: 1.25rem;
  line-height: 1.6;
  color: gray;
`;

export const StyledDateBox = styled.div`
  width: 100% !important;
  & .rmdp-container {
    width: 100% !important;
  }
`;

export const StyledStudentTitle = styled.span`
  color: #717171;
`;

export const StyledStudentName = styled.div`
  width: 100%;
  border-bottom: 1px solid #717171;
  padding: 6px;
`;

export const StyledCheckBoxGrid = styled(Grid)`
  display: flex !important;
  justify-content: left !important;
  align-items: center !important;
`;

export const ButtonContainer = styled.div`
  width: 100%;
  padding: 10px;
  text-align: left;
`;
